import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import type { SpaceToken } from "./Stack";
import styles from "./Spacer.module.css";

const sizeClass: Record<SpaceToken, string> = {
  4: styles.size4,
  8: styles.size8,
  12: styles.size12,
  16: styles.size16,
  24: styles.size24,
  36: styles.size36,
};

export interface SpacerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpaceToken;
}

export function Spacer({ className, size, ...rest }: SpacerProps) {
  return (
    <div
      className={cn(styles.spacer, size ? sizeClass[size] : undefined, className)}
      aria-hidden
      {...rest}
    />
  );
}
